import clsx from 'clsx'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import styles from './styles.module.scss'

import {
  Button,
  BUTTON_COLOR,
  BUTTON_WEIGHT,
} from '../../../../../atoms/fields'

export interface HouseOptionSubmitProps {
  confirm: boolean
  isValid: boolean
  isLoading: boolean
  onSubmit: () => void
  disabled?: boolean
  className?: string
}
const HouseOptionSubmit = ({
  confirm,
  isValid,
  onSubmit,
  isLoading,
  disabled = false,
  className,
}: HouseOptionSubmitProps) => {
  const intl = useIntl()
  return (
    <div className={clsx(styles.containerButtons, className)}>
      {confirm ? (
        <Button
          style={{ padding: '10px 20px' }}
          weight={BUTTON_WEIGHT.OUTLINED}
          color={BUTTON_COLOR.COLOR}
          disabled={disabled}
        >
          {intl.formatMessage({
            defaultMessage: 'Modifications enregistrées !',
            id: 'ui.HouseOptionSubmit.saved',
          })}
        </Button>
      ) : (
        <Button
          onClick={() => onSubmit()}
          weight={BUTTON_WEIGHT.OUTLINED}
          color={BUTTON_COLOR.COLOR}
          disabled={!isValid || disabled}
          loading={isLoading}
          style={{ padding: '10px 20px' }}
        >
          <FormattedMessage
            defaultMessage='Enregistrer les modifications'
            id='ui.HouseOptionSubmit.save'
          />
        </Button>
      )}
    </div>
  )
}

export default HouseOptionSubmit
